import React from "react";
import styles from "../AppearanceSettingForm/WidgetAppearanceForm.module.css";
import {useAppDispatch, useAppSelector} from "../../../../../../../app/hooks";
import {
    selectSurveyAfterBookingEnabled,
    selectSurveyAfterMessagesCount,
    selectSurveyAfterMessagesEnabled,
    updateFeedbackSettings
} from "../../widgetAppearanceUpdateSlice";
import {
    CustomSwitchFieldWithTitle
} from "../../../../../../elements/customSwitchFieldWithTitle/CustomSwitchFieldWithTitle";
import {ValidatedInputField} from "../../../../../../elements/validator/component/ValidatedInputField";
import {SurveyMessageCountValidator} from "../../../../../../elements/validator/Validator";
import {toSurveyMessageCount} from "../../../../surveySettings";

const SURVEY_MESSAGE_COUNT_FIELD = "surveyAfterMessagesCount";

interface FeedbackSettingsProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
    removeErrorByFieldName: (fieldName: string) => void;
}

export const FeedbackSettings: React.FC<FeedbackSettingsProps> = ({
                                                                      getMessageWrapper,
                                                                      updateValidationStatus,
                                                                      removeErrorByFieldName
                                                                  }) => {
    const dispatch = useAppDispatch();
    const isSurveyAfterMessagesEnabled = useAppSelector(selectSurveyAfterMessagesEnabled);

    const toggleSurveyAfterMessages = (enabled: boolean) => {
        if (!enabled) {
            // The count field is removed with the toggle, so it can no longer clear its own error.
            removeErrorByFieldName(SURVEY_MESSAGE_COUNT_FIELD);
        }
        dispatch(updateFeedbackSettings({surveyAfterMessagesEnabled: enabled}));
    };

    return (
        <div className={styles.formWrapper}>
            <CustomSwitchFieldWithTitle
                textOnTrue={"On"}
                textOnFalse={"Off"}
                title={"Survey After Messages"}
                description={"Show the satisfaction survey once the visitor has sent this many messages"}
                valueSelector={selectSurveyAfterMessagesEnabled}
                toggleValue={toggleSurveyAfterMessages}
            />
            {isSurveyAfterMessagesEnabled && <div className={styles.fieldsLine}>
                <ValidatedInputField<number, any>
                    onChange={(v) => dispatch(updateFeedbackSettings({surveyAfterMessagesCount: toSurveyMessageCount(v)}))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName={SURVEY_MESSAGE_COUNT_FIELD}
                    selector={selectSurveyAfterMessagesCount}
                    validator={SurveyMessageCountValidator}
                    label={"Visitor Messages Before Survey"}
                    placeholder={"e.g., 8"}
                    getMessage={getMessageWrapper}
                />
            </div>}
            <CustomSwitchFieldWithTitle
                textOnTrue={"On"}
                textOnFalse={"Off"}
                title={"Survey After Booking"}
                description={"Show the satisfaction survey right after a booked test drive or callback"}
                valueSelector={selectSurveyAfterBookingEnabled}
                toggleValue={(v) => dispatch(updateFeedbackSettings({surveyAfterBookingEnabled: v}))}
            />
        </div>
    );
};
